module.exports = "<div class=\"panic-part-container\" *ngIf=\"panicList.length != 0\">\r\n    <panic-alert *ngFor=\"let alert of panicList\" [alertData]=\"alert\" [isResolver]=\"alert.Resolver?alert.Resolver.StaffId == getCurretUserId():null\"></panic-alert>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/PanicAlert/panic-alert-list.component.html
// module id = ../../../../../app/shared/components/PanicAlert/panic-alert-list.component.html
// module chunks = main